import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {PromotionDto} from "../types/promotions.types";


@Injectable({ providedIn: 'root' })
export abstract class PromotionsApiService {

  endPoint: string = "mvseu/eu/endUser"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public getPromotions(): Observable<PromotionDto[]> {
    return this.coreApiService.get(`${this.endPoint}/promotions`);
  }


}
